<template>
    <div class="flex w-full justify-center bg-gray-100">
        <div
            class="relative flex min-h-screen w-full max-w-(--breakpoint-2xl) flex-col items-center py-6 sm:justify-center"
        >
            <div>
                <a :href="globalProps.homepage_url" target="_blank">
                    <PrimaryLogo height="200" width="200" />
                </a>
            </div>

            <div class="right-[20px] top-[20px] mt-5 sm:absolute sm:mt-0">
                <a :href="globalProps.homepage_url" target="_blank">
                    <AtomicButton size="md" color="yellow">
                        {{ $t("vue.go_to_homepage") }}
                    </AtomicButton>
                </a>
            </div>

            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

const globalProps = computed(() => usePage<IRhizomPageProps>().props);
</script>
